/**
 * O arquivo excluído no fim da aba Documentos (E216.F4.C03, GUS-317 P6, QA de 03/11): a exclusão
 * fazia o arquivo sumir da aba. Ele fica listado no fim, sem letra, com o nome e, no lugar do papel,
 * das páginas e da custódia, o registro da exclusão: o motivo (o fundamento na dica), quem excluiu e
 * quando. Sem ações: a exclusão não se desfaz, e para voltar a usar o arquivo o perito o envia de
 * novo por "Enviar documentos".
 */
import { TableBody, TableCell, TableRow } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { ExcluidoNaMesaData } from '@/lib/excluidos_na_mesa';
import { formatarDataHora } from '@/lib/trilha_format';

import { NomeNaTabela } from './LinhaDeDocumento';

const t = ptBR.documentosDoCaso;
const motivos: Partial<Record<string, string>> = ptBR.exclusaoNaMesa.motivos;

/** As colunas que o registro ocupa: Papel, Páginas e leitura, Código declarado × custódia. */
const COLUNAS_DO_REGISTRO = 3;

function quemEQuando(excluido: ExcluidoNaMesaData): string {
  const quando = formatarDataHora(excluido.instante);
  const quem = excluido.quem?.trim();
  if (quem === undefined || quem === '') return t.excluido.quando.replace('{quando}', quando);
  return t.excluido.porQuemQuando.replace('{quem}', quem).replace('{quando}', quando);
}

export function LinhaDoExcluido({ excluido }: { excluido: ExcluidoNaMesaData }): JSX.Element {
  const motivo = motivos[excluido.motivo] ?? excluido.motivo;
  return (
    <TableBody
      className="text-fg-muted"
      data-testid="linha-do-excluido"
      data-documento-id={excluido.documento_id}
    >
      <TableRow>
        <TableCell className="text-body-sm font-semibold tabular-nums" data-testid="linha-letra">
          {t.semLetra}
        </TableCell>
        <TableCell>
          <NomeNaTabela nome={excluido.arquivo} />
          <p className="mt-sc-1 text-caption text-fg-muted" data-testid="excluido-situacao">
            {t.excluido.situacao}
          </p>
        </TableCell>
        <TableCell colSpan={COLUNAS_DO_REGISTRO} className="text-body-sm text-fg-muted">
          <p title={excluido.fundamento} data-testid="excluido-motivo">
            {t.excluido.motivo.replace('{motivo}', motivo)}
          </p>
          <p className="text-caption" data-testid="excluido-quem-quando">
            {quemEQuando(excluido)}
          </p>
        </TableCell>
        <TableCell className="text-body-sm text-fg-muted" data-testid="linha-usado">
          {t.usado.nao}
        </TableCell>
        <TableCell />
      </TableRow>
    </TableBody>
  );
}
